export { default as BootMainPage } from './Main';
